import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from './supabaseClient';
import './App.css';

function Home() {
  const navigate = useNavigate();
  const [pageContent, setPageContent] = useState(null);
  const [loading, setLoading] = useState(true);

  const scrollToSection = (id) => {
    document.getElementById(id).scrollIntoView({ behavior: 'smooth' });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert('Mesajınız gönderildi! En kısa sürede size dönüş yapacağız.');
    e.target.reset();
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Fetch page content
        const { data: content, error: contentError } = await supabase
          .from('page_content')
          .select('*')
          .eq('id', 1)
          .single();

        if (contentError && contentError.code !== 'PGRST116') {
          console.error('Error fetching page content:', contentError);
        }

        setPageContent(content);
      } catch (err) {
        console.error('Error fetching data:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  // Handle hash-based navigation
  useEffect(() => {
    const hash = window.location.hash;
    if (hash) {
      const id = hash.substring(1); // Remove the # symbol
      setTimeout(() => {
        scrollToSection(id);
      }, 100);
    }
  }, []);

  if (loading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        fontSize: '1.2rem',
        color: '#666'
      }}>
        Yükleniyor...
      </div>
    );
  }

  // Default content if not loaded from database
  const content = pageContent || {
    hero_badge: 'ALTINEL PLASTİK',
    hero_title: 'BORMAK',
    hero_subtitle: 'Plastik Boru Kaynak Makinası',
    hero_description: 'Profesyonel plastik boru kaynak çözümleri ve kaliteli ekipmanlar',
    hero_button1: 'Ürünleri İncele',
    hero_button2: 'Fiyat Bilgisi Al',
    products_title: 'Ürün Kataloğumuz',
    products_subtitle: 'Geniş ürün yelpazemizle ihtiyacınıza uygun çözümler',
    about_title: 'Hakkımızda',
    about_paragraph1: 'BORMAK olarak, plastik boru kaynak sektöründe yılların verdiği deneyim ve uzmanlıkla, profesyonel çözümler sunuyoruz. Altinel Plastik çatısı altında, kaliteli ve güvenilir ürünlerle müşterilerimize hizmet vermekteyiz.',
    about_paragraph2: 'Geniş ürün yelpazemiz ile küçük çaplı borulardan büyük endüstriyel uygulamalara kadar her ihtiyaca uygun çözümler sunuyoruz. Otomatik ve manuel boru makasları, kalemtıraşlar ve profesyonel kaynak makineleri ile sektörde öncü konumdayız.',
    contact_title: 'İletişim',
    contact_subtitle: 'Fiyat bilgisi ve ürün kataloğu için bizimle iletişime geçin',
    contact_email: 'info@bormak.com',
    contact_phone: '+90 (XXX) XXX XX XX',
    contact_address: 'Altinel Plastik\nİstanbul, Türkiye',
    footer_text: '© 2025 BORMAK - Altinel Plastik. Tüm hakları saklıdır.',
    logo_url: '',
    hero_image_url: '',
    whatsapp_phone: ''
  };

  return (
    <div className="App">
      {/* Navigation */}
      <nav className="navbar">
        <div className="nav-container">
          <div className="logo">
            {content.logo_url ? (
              <img src={content.logo_url} alt="BORMAK" className="logo-image" />
            ) : (
              <span className="logo-text">BORMAK</span>
            )}
          </div>
          <ul className="nav-menu">
            <li><button onClick={() => scrollToSection('home')}>Ana Sayfa</button></li>
            <li><button onClick={() => navigate('/products')}>Ürünler</button></li>
            <li><button onClick={() => scrollToSection('about')}>Hakkımızda</button></li>
            <li><button onClick={() => scrollToSection('contact')}>İletişim</button></li>
          </ul>
        </div>
      </nav>

      {/* Hero Section */}
      <section id="home" className="hero" style={content.hero_image_url ? {
        backgroundImage: `url(${content.hero_image_url})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
      } : {}}>
        {content.hero_image_url && <div className="hero-image-overlay"></div>}
        <div className="hero-content">
          <div className="hero-badge">{content.hero_badge}</div>
          <h1 className="hero-title">{content.hero_title}</h1>
          <p className="hero-subtitle">{content.hero_subtitle}</p>
          <p className="hero-description">
            {content.hero_description}
          </p>
          <div className="hero-buttons">
            <button className="btn btn-primary" onClick={() => navigate('/products')}>
              {content.hero_button1}
            </button>
            <button className="btn btn-secondary" onClick={() => scrollToSection('contact')}>
              {content.hero_button2}
            </button>
          </div>
        </div>
        {!content.hero_image_url && <div className="hero-overlay"></div>}
      </section>

      {/* About Section */}
      <section id="about" className="about">
        <div className="container">
          <div className="about-content">
            <div className="about-text">
              <h2 className="section-title">{content.about_title}</h2>
              <p>
                {content.about_paragraph1}
              </p>
              <p>
                {content.about_paragraph2}
              </p>
              <div className="features">
                <div className="feature-item">
                  <span className="feature-icon">✓</span>
                  <span>Yüksek Kalite</span>
                </div>
                <div className="feature-item">
                  <span className="feature-icon">✓</span>
                  <span>Profesyonel Hizmet</span>
                </div>
                <div className="feature-item">
                  <span className="feature-icon">✓</span>
                  <span>Geniş Ürün Yelpazesi</span>
                </div>
                <div className="feature-item">
                  <span className="feature-icon">✓</span>
                  <span>Güvenilir Çözümler</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section id="contact" className="contact">
        <div className="container">
          <h2 className="section-title">{content.contact_title}</h2>
          <p className="section-subtitle">{content.contact_subtitle}</p>
          
          <div className="contact-content">
            <div className="contact-info">
              <div className="contact-item">
                <div className="contact-icon">📧</div>
                <div>
                  <h4>E-posta</h4>
                  <p>{content.contact_email}</p>
                </div>
              </div>
              <div className="contact-item">
                <div className="contact-icon">📞</div>
                <div>
                  <h4>Telefon</h4>
                  <p>{content.contact_phone}</p>
                </div>
              </div>
              <div className="contact-item">
                <div className="contact-icon">📍</div>
                <div>
                  <h4>Adres</h4>
                  <p style={{ whiteSpace: 'pre-line' }}>{content.contact_address}</p>
                </div>
              </div>
            </div>
            
            <form className="contact-form" onSubmit={handleSubmit}>
              <div className="form-group">
                <input type="text" placeholder="Adınız Soyadınız" required />
              </div>
              <div className="form-group">
                <input type="email" placeholder="E-posta Adresiniz" required />
              </div>
              <div className="form-group">
                <input type="tel" placeholder="Telefon Numaranız" required />
              </div>
              <div className="form-group">
                <textarea placeholder="Mesajınız" rows="5" required></textarea>
              </div>
              <button type="submit" className="btn btn-primary">Gönder</button>
            </form>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <div className="container">
          <div className="footer-content">
            <div className="footer-brand">
              <h3>BORMAK</h3>
              <p>Plastik Boru Kaynak Makinası</p>
            </div>
            <div className="footer-links">
              <button onClick={() => scrollToSection('home')}>Ana Sayfa</button>
              <button onClick={() => navigate('/products')}>Ürünler</button>
              <button onClick={() => scrollToSection('about')}>Hakkımızda</button>
              <button onClick={() => scrollToSection('contact')}>İletişim</button>
            </div>
          </div>
          <div className="footer-bottom">
            <p>{content.footer_text}</p>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default Home;

